import TocIcon from '@presentation/assets/route/TOC.png'
import TodIcon from '@presentation/assets/route/TOD.png'
import { CircleLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl'

import { MAP_SYMBOL_PRIORITIES } from '../MapRoute/GeojsonUtils'

export { TocIcon, TodIcon }

// TOC

export const tocPointLayoutStyle = (): CircleLayerSpecification['layout'] => ({
  'circle-sort-key': MAP_SYMBOL_PRIORITIES.ROUTE_TOC_TOD_POINT
})

export const tocPointPaintStyle = (): CircleLayerSpecification['paint'] => ({
  'circle-color': '#FCFCFC',
  'circle-radius': 6,
  'circle-stroke-width': 1.2,
  'circle-stroke-color': '#000000'
})

export const tocLabelLayoutStyle = (): SymbolLayerSpecification['layout'] => ({
  'symbol-sort-key': MAP_SYMBOL_PRIORITIES.ROUTE_TOC_TOD_LABEL,
  'symbol-z-order': 'source',
  'icon-text-fit': 'both',
  'icon-offset': [0, -15]
})

// TOD

export const todPointLayoutStyle = (): CircleLayerSpecification['layout'] => ({
  'circle-sort-key': MAP_SYMBOL_PRIORITIES.ROUTE_TOC_TOD_POINT
})

export const todPointPaintStyle = (): CircleLayerSpecification['paint'] => ({
  'circle-color': '#FCFCFC',
  'circle-radius': 6,
  'circle-stroke-width': 1.2,
  'circle-stroke-color': '#000000'
})

export const todLabelLayoutStyle = (): SymbolLayerSpecification['layout'] => ({
  'symbol-sort-key': MAP_SYMBOL_PRIORITIES.ROUTE_TOC_TOD_LABEL,
  'symbol-z-order': 'source',
  'icon-text-fit': 'both',
  'icon-offset': [0, -15]
})
